<template>
  <div class="collapsable-images-category-container">
    <div v-if="images">
      <CollapsableCategory
        value="Images"
        :color="getColor(foreground_color)"
        :init_expanded="false"
      >
        <template #content="{ is_collapsed, }">
          <!-- LIST -->
          <TransitionAccordion>
            <div
              v-if="!is_collapsed"
            >
              <ClickableListItem
                v-for="image in images"
                :key="image.description"
                :id="image.id"
                :is_selected="image.id === selected_id"
                :margin="2"
                :is_completely_clickable="true"
                :background_color="getColor(background_color)"
                :foreground_color="getColor(foreground_color)"
                @emittedClick="handleClick(image)"
              >
                <template #front>
                  <img
                    class="collapsable-images-category-list-front-slot"
                    :src="image.image"
                  />
                </template>

                <template #descriptor>
                  <div class="collapsable-images-category-list-description">
                    <TText
                      :text="image.description"
                      :color="getColor(foreground_color)"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                    <TText
                      :text="image.step"
                      :color="getColor(foreground_color)"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                    <TText
                      :text="image.date.split(' UTC')[0]"
                      :color="getColor(foreground_color)"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                    <TText
                      :text="`${image.pers.first_name} ${image.pers.last_name}`"
                      :color="getColor(foreground_color)"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                  </div>
                </template>
              </ClickableListItem>
            </div>
          </TransitionAccordion>

          <!-- GALLERY -->
          <TransitionAccordion>
            <Gallery
              v-if="is_collapsed"
              :image_links="image_links"
              :border_radius="5"
              @emittedClick="$emit('emittedClick', $event)"
            />
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </div>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import Gallery from '@/components/WorkPackageWIP/Gallery.component.vue';
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

  export default {
    components: {
      ClickableListItem,
      TText,
      Gallery,
      CollapsableCategory,
      TransitionAccordion,
    },

    mixins: [
      TColor,
    ],

    props: [
      'images', // is array of objects, contains description, step, date, person (string)
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
    ],

    computed: {
      image_links() {
        let img_links = [];
        for(let i = 0; i < this.images.length; i++) {
          img_links.push(this.images[i].image);
        }
        return img_links;
      },
    },

    data: () => ({
      selected_id: -1,
    }),

    methods: {
      handleClick(image) {
        this.selected_id = image.id;
        this.$emit('emittedClick', image.description)
      },

      resetSelectedId() {
        this.selected_id = -1;
      },
    },
  }
</script>

<style>
  .collapsable-images-category-container {
    position: relative;
  }
  .collapsable-images-category-list-front-slot {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 5px;
  }
  .collapsable-images-category-list-description {
     display: flex;
     flex-direction: column;
     pointer-events: none;
  }
</style>
